<app-dialog [dialogWithInput]="dialog">
    <app-view-by-id-default
            [id]="dialog.input.id"
            [findByIdService]="workflowTaskFindOneByIdService"
            (entityLoaded)="entityLoaded($event)">
        <ng-container *ngIf="entity">
            <div class="row">
                <div class="col-12">
                    <app-card-v2 [hideHeader]="true">
                        <div class="row">
                            <app-form-field label="Date de création">
                                <app-datetime-summary-field [datetime]="entity.summary.createdAt"></app-datetime-summary-field>
                            </app-form-field>
                            <app-form-field label="Date de début" *ngIf="entity.summary.executionStart">
                                <app-datetime-summary-field [datetime]="entity.summary.executionStart"></app-datetime-summary-field>
                            </app-form-field>
                            <app-form-field label="Date de fin" *ngIf="entity.summary.executionEnd">
                                <app-datetime-summary-field [datetime]="entity.summary.executionEnd"></app-datetime-summary-field>
                            </app-form-field>
                            <app-form-field label="Statut">
                                <app-workflow-task-status-summary-field [task]="entity.summary"></app-workflow-task-status-summary-field>
                            </app-form-field>
                        </div>
                        <div class="row">
                            <app-form-field label="Destinataire">
                                <app-email-summary-field [email]="payload.to"></app-email-summary-field>
                                <app-partner-summary-field [partnerSummary]="entity.summary.partner" *ngIf="entity.summary.partner"></app-partner-summary-field>
                            </app-form-field>
                            <app-form-field label="Expéditeur">
                                <app-email-summary-field [email]="payload.replyTo"></app-email-summary-field>
                            </app-form-field>
                            <app-form-field label="Documents joints">
                                <app-document-summary-field-by-id *ngFor="let docId of documentIds" [id]="docId"></app-document-summary-field-by-id>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
                <div class="col-12">
                    <app-card-v2 title="Sujet">
                        <div class="row">
                            <app-form-field size="12">
                                <app-summary-field>{{payload.subject}}</app-summary-field>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
                <div class="col-12">
                    <app-card-v2 title="Contenu">
                        <div class="row">
                            <app-form-field size="12">
                                <div [innerHTML]="payload.content | keepHtml"></div>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
                <div class="col-12" *ngIf="(authService.tokenContent$ | async)?.superUser">
                    <app-card-v2 title="Stacktrace">
                        <div class="row">
                            <app-form-field size="12">
                                <div *ngIf="entity.errorStackTrace">{{entity.errorStackTrace}}</div>
                                <div *ngIf="!entity.errorStackTrace">Aucune</div>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
            </div>
        </ng-container>
    </app-view-by-id-default>
</app-dialog>
